import { makeAutoObservable } from 'mobx';
import { IABTestsParams, getABTestsParams } from './types';

export interface IABTestsStore {
	params: IABTestsParams;
	setSearchParams: (params: URLSearchParams) => void;
}

export class ABTestsStore implements IABTestsStore {
	params: IABTestsParams;

	constructor(params: URLSearchParams) {
		makeAutoObservable(this);
		this.params = getABTestsParams(params);
	}

	setSearchParams = (params: URLSearchParams): void => {
		this.params = getABTestsParams(params);
	};
}
